import gql from 'graphql-tag'

export const deleteDocument = gql`
  mutation deleteDocument($documentUuid: String!, $workspaceId: Float!) {
    deleteDocument(document_uuid: $documentUuid, workspace_id: $workspaceId) {
      status
      msg
      data
    }
  }
`
